import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { colors } from '../../styles/constants';

interface FilterOption {
  label: string;
  value: string;
}

interface QuickFiltersProps {
  options: FilterOption[];
  selectedFilter: string;
  onFilterChange: (filter: string) => void;
}

const QuickFilters: React.FC<QuickFiltersProps> = ({
  options,
  selectedFilter,
  onFilterChange
}) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 3,
        backgroundColor: colors.background.card,
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" component="div" sx={{ fontWeight: 'medium', mb: 2 }}>
        Quick Filters
      </Typography>
      
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {options.map((option) => (
          <Button
            key={option.value}
            variant={selectedFilter === option.value ? 'contained' : 'outlined'}
            color={selectedFilter === option.value ? 'secondary' : 'primary'}
            onClick={() => onFilterChange(option.value)}
            sx={{ 
              mb: { xs: 1, sm: 0 },
              borderColor: colors.secondary.darkSolid,
              '&.MuiButton-contained': {
                backgroundColor: colors.secondary.darkSolid,
              }
            }}
          >
            {option.label}
          </Button>
        ))}
      </Box>
    </Paper>
  );
};

export default QuickFilters;
